export const TOKEN_KEY = 'vks_support_widget_token';
export const OLD_TOKEN_KEY = 'vks_support_widget_token_oldToken';
export const VKID_AUTOLOGIN_KEY = 'vkid_auth_by_autologin_timestamp';
export const HAS_WIDGET_HISTORY = 'vks_support_widget_token_has_widget_history';
export const LAST_SEEN_MESSAGE_ID = 'vks_support_widget_token_lastSeenMessageId';
export const HAS_MAX_USER_PHONE = 'vks_support_widget_has_max_user_phone';
